import React, { FC } from 'react'

import Lottie from 'lottie-react'

import animationData from './assets/robot.json'

export const Robot: FC = () => {
  return <Lottie animationData={animationData} />
}

export default Robot
